import InlineComponent from './inlineComponent.jsx';
import DockerImagesTextbox from '../../../components/output_textbox/DockerImagesTextbox.jsx';

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = DockerImagesTextbox;
    this.data = {
      hostname: this.element.data('hostname'),
      images: this.element.data('images'),
      date: this.element.data('date'),
      updateChannel: this.element.data('updatechannel'),
      list: this.element.data('list'),
      details: this.element.data('details'),
      error: this.element.data('error'),
      logs: this.element.data('logs'),
    };
  }
};
